export default __webpack_public_path__ + "static/media/happy.11e434a8.svg";